import { Component } from '@angular/core';
import { LoginService } from "app/services/login/login.service";

@Component({
  selector: 'app-inversionistas',
  templateUrl: './inversionistas.component.html',
  styleUrls: ['./inversionistas.component.scss']
})
export class InversionistasComponent   {

  constructor(private loginService: LoginService) { }

  
  
  clickGuard(){
    this.loginService.clickGuard = true;
  }
}
